import { NavigationItem } from '../../../../data/types';
import { createTag, mapTags } from '../../../../modules/tag-creators';
import { DropdownArrow } from '../../../DropdownArrow/DropdownArrow';
import headerCss from '../Navigation.scss';
import s from './MoreMenu.scss';

interface SubMenuProps {
  labelledBy: string;
  items: NavigationItem[] | undefined;
  t(key: string): string;
}

const SubMenu = ({ labelledBy, items, t }: SubMenuProps) => {
  if (!items || !items.length) {
    return '';
  }
  return `
    <div
      class="${s.subMenuContainer} items-${items.length}"
      role="region"
      aria-labelledby="${labelledBy}"
    >
      <ul class="${s.subMenu}">
        ${mapTags(
          items,
          item => `
          <li class="${s.subMenuItem}">
            ${createTag('a', t(item.text), {
              class: `${s.link} ${headerCss.biLink}`,
              target: item.target,
              href: item.href,
              tabindex: '0',
              'data-bi-name': item.name,
              'data-bi-row': 'second',
            })}
          </li>
        `,
        )}
      </ul>
    </div>
  `;
};

interface MenuItemProps {
  item: NavigationItem;
  t(key: string): string;
}

export const MoreMenuItemButton = ({ item, t }: MenuItemProps, id: string) => {
  if (item.href) {
    return createTag('a', t(item.text), {
      id,
      class: `${s.link} ${headerCss.biLink}`,
      target: item.target,
      href: item.href,
      'data-bi-name': item.name,
      'data-bi-row': 'first',
    });
  }

  return `
    <button
      class="${s.link} ${headerCss.biLink}"
      data-bi-name="${item.name}"
      data-bi-row="first"
      data-toggle="collapse"
      aria-expanded="false"
    >
      ${t(item.text)}
      ${DropdownArrow(s.arrow)}
    </button>
  `;
};

export const MoreMenuItem = ({ item, t }: MenuItemProps) => {
  const id = `more-menu-item-${item.name}`;
  return `
    <li
      class="${s.menuItem}"
      data-expanded="false"
    >
      ${MoreMenuItemButton({ item, t }, id)}
      ${SubMenu({ labelledBy: id, items: item.subs, t })}
    </li>
  `;
};

interface MenuProps {
  className?: string;
  items: NavigationItem[];
  t(key: string): string;
}

export const MoreMenu = ({ className, items, t }: MenuProps) => {
  return `
    <li class="${className} ${s.moreMenuWrapper}">
      <button class="${s.link}" title="${t('menu_more')}">
        ${t('menu_more')}
        ${DropdownArrow(s.arrow)}
      </button>
      <div class="${s.moreMenuContainer} items-${items.length}">
        <ul class="${s.moreMenu}">
          ${mapTags(items, item => MoreMenuItem({ item, t }))}
        </ul>
      </div>
    </li>
  `;
};
